import React, { useState } from 'react';
import {
  IonHeader,
  IonContent,
  IonToolbar,
  IonSegment,
  IonSegmentButton,
  IonLabel,
  IonItem,
  IonFab,
  IonFabButton,
  IonIcon,
  IonFabList,
  IonRow,
  IonGrid,
} from '@ionic/react';
import { add, pencil, codeSlash } from 'ionicons/icons';
import PostList from '../components/post/PostList';

export default function Dash() {
  if (!localStorage.token) {
    window.location = '/login';
  }

  const [stat, setStat] = useState('latest');

  return (
    <IonContent fullscreen>
      <IonHeader>
        <IonToolbar color='primary'>
          <IonItem slot='start' color='primary'>
            <IonSegment onIonChange={(e) => setStat(e.detail.value)} value={stat}>
              <IonSegmentButton value='latest'>
                <IonLabel className='ion-text-capitalize'>Latest</IonLabel>
              </IonSegmentButton>
              <IonSegmentButton value='top'>
                <IonLabel className='ion-text-capitalize'>Top</IonLabel>
              </IonSegmentButton>
            </IonSegment>
          </IonItem>
        </IonToolbar>
      </IonHeader>

      <IonFab vertical='bottom' horizontal='end' slot='fixed' className='ion-margin'>
        <IonFabButton color='secondary'>
          <IonIcon icon={add} />
        </IonFabButton>
        <IonFabList side='top'>
          <IonFabButton color='dark' href={`http://localhost:3000/profile/${localStorage.token}`} target='_blank'>
            <IonIcon icon={codeSlash} />
          </IonFabButton>
          <IonFabButton color='dark' href='/submit'>
            <IonIcon icon={pencil} />
          </IonFabButton>
        </IonFabList>
      </IonFab>

      <IonGrid>
        <IonRow className='ion-justify-content-center ion-align-items-center'>
          <PostList stat={stat} />
        </IonRow>
      </IonGrid>
    </IonContent>
  );
}
